import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

//import store from "./store";
import { Toast, options } from "./plugins/notification";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { VuetifyPlugin } from "./plugins/vuetify";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { vPhoneInput } from "./plugins/vuetifyPhoneInput";

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
import VuetifyMask from "vuetify-mask/index.js";
import { createPinia } from "pinia";
import './assets/fonts/Lato/latofonts.css'

const pinia = createPinia();
createApp(App)
  // .use(store)
  .use(pinia)
  .use(router)
  .use(VuetifyPlugin)
  .use(VuetifyMask)
  .use(vPhoneInput)
  .use(Toast, options)
  .mount("#app");
